export const getFullName = (translator, data) => {
  const profile = data.find((profile) => profile["mainGuest"] === true);
  if (profile && profile["firstName"]) {
    return `${profile["firstName"]} ${profile["lastName"]}`;
  }
  return translator("common.dear");
};
export const getFormattedCurrencyValue = (
  value,
  currencyCode = "USD",
  locale
) => {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode,
  }).format(value);
};
export function formatMoney(value, currencyConfig) {
  const precision = Number.isInteger(currencyConfig.precision)
    ? currencyConfig.precision
    : 2;

  let result = Math.abs(value).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  });

  result = result.substring(1);

  const separators = {
    ".": currencyConfig.decimalSeparator || ".",
    ",": currencyConfig.thousandSeparator || ",",
  };

  result = result.replace(/[.,]/g, (m) => separators[m === "." ? "." : ","]);

  if (currencyConfig.symbol) {
    if (currencyConfig.symbolAtTheEnd) {
      result = result + currencyConfig.symbolSeparator + currencyConfig.symbol;
    } else {
      result = currencyConfig.symbol + currencyConfig.symbolSeparator + result;
    }
  }

  if (value < 0) {
    result = "-" + result;
  }

  return result;
}
export function groupBy(xs, key) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
}
